import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/SSOButton/logos.tsx
function GoogleLogo() {
	return /* @__PURE__ */ jsxs("svg", {
		className: "ds-sso-button__logo",
		viewBox: "0 0 24 24",
		"aria-hidden": "true",
		focusable: "false",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: "#4285F4",
				d: "M23.06 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h6.2a5.3 5.3 0 0 1-2.3 3.48v2.88h3.72c2.18-2 3.44-4.96 3.44-8.37z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#34A853",
				d: "M12 24c3.12 0 5.73-1.03 7.64-2.8l-3.72-2.88c-1.03.7-2.36 1.1-3.92 1.1-3.01 0-5.56-2.03-6.47-4.77H1.68v2.97A11.99 11.99 0 0 0 12 24z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#FBBC05",
				d: "M5.53 14.65a7.2 7.2 0 0 1 0-4.6V7.08H1.68a12 12 0 0 0 0 10.54l3.85-2.97z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#EA4335",
				d: "M12 4.77c1.7 0 3.22.58 4.42 1.73l3.3-3.3C17.72 1.2 15.11 0 12 0A11.99 11.99 0 0 0 1.68 7.08l3.85 2.97C6.44 7.31 8.99 4.77 12 4.77z"
			})
		]
	});
}
function MicrosoftLogo() {
	return /* @__PURE__ */ jsxs("svg", {
		className: "ds-sso-button__logo",
		viewBox: "0 0 21 21",
		"aria-hidden": "true",
		focusable: "false",
		children: [
			/* @__PURE__ */ jsx("rect", {
				x: "1",
				y: "1",
				width: "9",
				height: "9",
				fill: "#F25022"
			}),
			/* @__PURE__ */ jsx("rect", {
				x: "11",
				y: "1",
				width: "9",
				height: "9",
				fill: "#7FBA00"
			}),
			/* @__PURE__ */ jsx("rect", {
				x: "1",
				y: "11",
				width: "9",
				height: "9",
				fill: "#00A4EF"
			}),
			/* @__PURE__ */ jsx("rect", {
				x: "11",
				y: "11",
				width: "9",
				height: "9",
				fill: "#FFB900"
			})
		]
	});
}
//#endregion
export { GoogleLogo, MicrosoftLogo };

//# sourceMappingURL=logos.js.map